document.addEventListener('DOMContentLoaded', function () {
    const swatches = document.querySelectorAll('[data-swatch-item]');

    const launchDateCell = document.getElementById('launch-date-cell');
    const launchDateRow = document.getElementById('launch-date-row');

    const giftElement = document.querySelectorAll('[data-gift-id]');
    function updateGift(check) {
        giftElement.forEach(el => {
            const giftId = el.dataset.giftId;
            if (check === giftId) {
                el.style.display = 'flex'
            } else {
                el.style.display = 'none'
            }
        })
    }

    if (!swatches.length || !launchDateCell || !launchDateRow) return;

    const updateLaunchDate = (launchDate) => {
    if (launchDate && launchDate.trim() !== '') {
    launchDateCell.textContent = launchDate;
    launchDateRow.style.display = '';
} else {
    launchDateCell.textContent = '';
    launchDateRow.style.display = 'none';
}
};

    swatches.forEach((swatch) => {
    swatch.addEventListener('click', function () {
    const launchDate = swatch.dataset.launchDate;
    const giftChecked = swatch.dataset.giftSetDetails;
    updateLaunchDate(launchDate);
    updateGift(giftChecked);
});
});

    const initiallySelected = document.querySelector('[data-swatch-item].is--selected');
    if (initiallySelected) {
    const launchDate = initiallySelected.dataset.launchDate;
    updateLaunchDate(launchDate);
}
});